import FeatureFlagWebClient from '@atlassiansox/feature-flag-web-client';
import { MarketplaceFeatureFlagsClient } from '../marketplace-feature-flags-client';
import statsigClient from '../statsig-client';
import { getFeatureFlagUser } from './featureFlagUser';
function initializeLdClient(productKey, apiKey, environment, user, analyticsClient) {
  const clientOptions = {
    productKey,
    environment
  };
  return new FeatureFlagWebClient(apiKey, analyticsClient, user, clientOptions);
}
export async function getFeatureFlagsClient(_ref) {
  let {
    apiKey,
    environment,
    userId,
    additionalIds,
    analyticsClient,
    productKey,
    customAttributes,
    statsig,
    statsigCustomAttributes,
    initializeStatsig = false
  } = _ref;
  const user = getFeatureFlagUser(userId, additionalIds, customAttributes);
  let flagClientsInitPromises = [initializeLdClient(productKey, apiKey, environment, user, analyticsClient)];
  if (initializeStatsig) {
    flagClientsInitPromises = [...flagClientsInitPromises, statsigClient.initializeStatsigClient({
      clientKey: statsig.clientKey,
      environment: statsig.environment,
      targetApp: statsig.targetApp,
      marketplaceAnonymousId: userId
    }, statsigCustomAttributes)];
  }
  const responses = await Promise.all(flagClientsInitPromises);
  const featureFlagsClient = responses[0];
  await featureFlagsClient.ready();
  return new MarketplaceFeatureFlagsClient(featureFlagsClient, user, initializeStatsig ? statsigClient : undefined);
}